export default "__VITE_ASSET__Cv5ie9ZB__"